import { render, staticRenderFns } from "./SeparatePets.vue?vue&type=template&id=0584d45f"
import script from "./SeparatePets.vue?vue&type=script&lang=js"
export * from "./SeparatePets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports